export async function fetchPricing(numberOfUsers: number) {
  return fetch(`/api/_private/plans/pricing.json?number_of_users=${numberOfUsers}`)
    .then(handleErrors)
    .then((res) => res.json())
    .catch((err) => console.error(err.responseText));
}

const handleErrors = (res: any) => {
  if (!res.ok) {
    // eslint-disable-next-line no-alert
    alert('Something went wrong with your request. Please refresh the page');
    throw Error(res.statusText);
  }
  return res;
};
